var _path, _path2, _path3, _path4, _circle, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDayBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55601 1.02029C8.36587 0.70602 10.4497 0.117363 12.3064 0.276917V8.2546C11.4784 8.2546 9.23495 8.48305 6.88516 9.39686C5.93026 8.9738 3.47651 8.17119 1.30078 8.34525V0.276917C2.52161 0.222523 5.32951 0.3857 6.79451 1.47357V2.23507",
    stroke: "#262626",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8125 9.38833V4.14844",
    stroke: "#262626",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3016 1.23438L0.25 1.56073V9.57468C1.24117 9.43568 3.93787 9.33172 6.79533 10.028C7.78045 9.78621 10.4506 9.35711 13.25 9.57468V1.56073L12.3253 1.23438",
    stroke: "#262626",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28027 3.67285C5.54175 3.69638 4.93967 3.77879 4.55273 3.85938L5.36426 5.59473L5.48535 5.85254H3.01953L3.15234 5.58984L4.13184 3.65039L4.16895 3.57715L4.24707 3.55664C4.61601 3.45977 5.30424 3.34597 6.18457 3.3125L6.28027 3.67285ZM7.34277 3.31738C7.82019 3.3402 8.32909 3.38996 8.85547 3.47656L9.2793 3.55371L9.36426 3.57129L9.4043 3.64844L10.4014 5.58887L10.5381 5.85254H8.01074L8.1377 5.59277L8.97559 3.86621C8.39675 3.76215 7.83792 3.70514 7.31836 3.68066L7.34277 3.31738ZM3.60938 5.49023H4.91602L4.28613 4.14648L3.60938 5.49023ZM8.59082 5.49023H9.94336L9.24707 4.13672L8.59082 5.49023Z",
    fill: "#262626"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.79722,
    cy: 3.46714,
    r: 0.529637,
    stroke: "#262626",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34766 6.96094C3.98651 6.961 3.5523 6.92929 3.2627 6.5293C3.1456 6.36754 3.08776 6.14081 3.06348 5.93359C3.05878 5.89341 3.05893 5.85488 3.05664 5.81934L5.53613 5.81934C5.53543 5.83164 5.53617 5.84445 5.53516 5.85742C5.52258 6.01849 5.48543 6.21069 5.39648 6.375C5.20916 6.72086 4.7918 6.96078 4.34766 6.96094Z",
    stroke: "#262626",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2793 6.96094C8.91815 6.961 8.48394 6.92929 8.19434 6.5293C8.07724 6.36754 8.0194 6.14081 7.99512 5.93359C7.99042 5.89341 7.99057 5.85488 7.98828 5.81934L10.4678 5.81934C10.4671 5.83164 10.4678 5.84445 10.4668 5.85742C10.4542 6.01849 10.4171 6.21069 10.3281 6.375C10.1408 6.72086 9.72344 6.96078 9.2793 6.96094Z",
    stroke: "#262626",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayBook);
export default __webpack_public_path__ + "static/media/day-book.22f64a01450312105997d21bbfe50053.svg";
export { ForwardRef as ReactComponent };